import type { HealthSummary } from "@vaulted/shared";
import { cx } from "./ui";

/** Allergies, medications, conditions, and today's changes; anything flagged in red. */
export function HealthBlock({ h }: { h: HealthSummary }) {
  return (
    <div className="flex flex-col gap-2 text-sm">
      {h.flags.length > 0 && (
        <div role="alert" className="rounded-[var(--radius-control)] bg-danger-wash px-3 py-2 font-semibold text-danger">
          {h.flags.map((x) => (
            <div key={x}>⚠ {x}</div>
          ))}
        </div>
      )}
      <dl className="grid gap-x-6 gap-y-1.5 sm:grid-cols-2">
        <div>
          <dt className="text-muted">Allergies</dt>
          <dd className={cx("font-semibold", h.allergies && !/^(none|nkda|no)\.?$/i.test(h.allergies.trim()) && "text-danger")}>{h.allergies || (h.intakeSignedAt ? "None listed" : "No intake yet")}</dd>
        </div>
        <div>
          <dt className="text-muted">Medications</dt>
          <dd className="font-semibold">{h.medications || "None listed"}</dd>
        </div>
        <div>
          <dt className="text-muted">Conditions</dt>
          <dd className="font-semibold">{[...h.conditions, h.conditionsOther].filter(Boolean).join(", ") || "None listed"}</dd>
        </div>
        <div>
          <dt className="text-muted">Changes today</dt>
          <dd className="font-semibold">{[...h.changes, h.changesDetail].filter(Boolean).join("; ") || (h.consentSignedAt ? "None" : "No consent for this visit yet")}</dd>
        </div>
      </dl>
    </div>
  );
}
